import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AadeBookInvoiceType  {
    _originalTypeClassName = "zERP.BO.AadeBookInvoiceType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AadeBookInvoiceType.translate = translateService;
}
this.PaymentOrderInvoices = [];
this.PaymentMethods = [];
this.InvoiceDetails = [];
this.TaxesTotals = [];
this.Entity = new Domain.BusinessEntity();
this.VATTotals = [];
this.GeneralJournals = [];
this.CorrelatedInvoicesOpposite = [];
this.CorrelatedInvoices = [];
this.DeliveryNotes = [];
this.ExternalInvoiceInfo = [];
this.FileUploads = [];
this.Id = null;
this.UID = null;
this.Mark = null;
this.ClassificationMark = null;
this.CancelledByMark = null;
this.CancellationDate = null;
this.AuthenticationCode = null;
this.Source = null;
this.TransactionType = null;
this.Status = null;
this.SourceStr = null;
this.DocumentStatus = null;
this.ConnectionStatus = null;
this.DateUpdated = null;
this.EntryStatus = null;
this.ERPAA = null;
this.ERPDocID = null;
this.IsCurrent = true;
this.ConnectionStatusDescription = null;
this.ClassificationStatus = null;
this.ERPStatus = null;
this.TaxesPerInvoiceLine = false;
this.ManualVATCalculation = false;
this.HasMultipleBudgetItems = false;
this.MyDataSyncStatus = null;
this.MyDataSyncStatusStr = null;
this.CorrelatedInvoicesStr = null;
this.ToBeIssued = null;
this.PaidAmount = null;
this.CreditAmount = null;
this.RemainingAmount = null;
this.QrCodeUrl = null;
this.MappedWithAccounting = false;
this.IsIssuing = false;
this.BackOfficeDocumentType = null;
this.ExternalSourceId = null;
this.ExternalReferenceId = null;
this.ExternalMyDataInfoSentDate = null;
this.IsPaid = false;
this.BackOfficeDocumentTypeStr = null;
this.PaymentMethodStr = null;
this.ProtocolNumber = null;
this.MyDataSyncDate = null;
this.FiscalYear = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
UID:any;
Mark:any;
ClassificationMark:any;
CancelledByMark:any;
CancellationDate:any;
AuthenticationCode:any;
Source:any;
TransactionType:any;
Status:any;
SourceStr:any;
DocumentStatus:any;
ConnectionStatus:any;
DateUpdated:any;
EntryStatus:any;
ERPAA:any;
ERPDocID:any;
IsCurrent:any;
ConnectionStatusDescription:any;
ClassificationStatus:any;
ERPStatus:any;
TaxesPerInvoiceLine:any;
ManualVATCalculation:any;
HasMultipleBudgetItems:any;
MyDataSyncStatus:any;
MyDataSyncStatusStr:any;
CorrelatedInvoicesStr:any;
ToBeIssued:any;
PaidAmount:any;
CreditAmount:any;
RemainingAmount:any;
QrCodeUrl:any;
MappedWithAccounting:any;
IsIssuing:any;
BackOfficeDocumentType:any;
ExternalSourceId:any;
ExternalReferenceId:any;
ExternalMyDataInfoSentDate:any;
IsPaid:any;
BackOfficeDocumentTypeStr:any;
PaymentMethodStr:any;
ProtocolNumber:any;
MyDataSyncDate:any;
FiscalYear:any;
PaymentOrderInvoices:any;
IncomeReceipt:any;
ResponseLog:any;
Issuer:any;
Counterpart:any;
InvoiceHeader:any;
PaymentMethods:any;
InvoiceDetails:any;
TaxesTotals:any;
InvoiceSummary:any;
RelatedAADEBookingType:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
RelatedERPAADEBookingType:any;
TransmissionFailure:any;
Entity:any;
TransactionEntity:any;
VATTotals:any;
GeneralJournals:any;
CorrelatedInvoicesOpposite:any;
CorrelatedInvoices:any;
DeliveryNotes:any;
WithheldTaxReportSummary:any;
Project:any;
ExternalInvoiceInfo:any;
Cashier:any;
CanceledBy:any;
IssuedBy:any;
CreatedBy:any;
Cancellation:any;
CancellationInvoice:any;
FileUploads:any;
AdvancePayments:any;
static setPaymentOrderInvoices = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrderInvoices == null) $this.PaymentOrderInvoices = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrderInvoices.length > 0) {
                    Domain.AadeBookInvoiceType.removePaymentOrderInvoices($this, $this.PaymentOrderInvoices[0]);
                }

                Domain.AadeBookInvoiceType.addManyPaymentOrderInvoices($this, copyItems);
            }
static addManyPaymentOrderInvoices = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addPaymentOrderInvoices($this, items[i]);
                }
            }
static addPaymentOrderInvoices = ($this, item) => {
                if ($this.PaymentOrderInvoices == null) $this.PaymentOrderInvoices = [];
                if (item == null || $this.PaymentOrderInvoices.indexOf(item) > -1) return;
                $this.PaymentOrderInvoices.push(item);
if (item.Invoice != $this) {
Domain.PaymentOrderInvoice.setInvoice(item, $this);
}
}
static addRangePaymentOrderInvoices = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addPaymentOrderInvoices($this, item));
            }
static removePaymentOrderInvoices = ($this, item) => {
                if ($this == null || $this.PaymentOrderInvoices == null || $this.PaymentOrderInvoices.indexOf(item) === -1) return;
                var _index = $this.PaymentOrderInvoices.indexOf(item);
                $this.PaymentOrderInvoices.splice(_index, 1);
item.Invoice = null;
}
static clearPaymentOrderInvoices = ($this) => { $this.PaymentOrderInvoices = null; }
static setIncomeReceipt = ($this, value) => {
var oldValue = $this.IncomeReceipt;
$this.IncomeReceipt = value;
if (value != null) {
if (oldValue != null) {
Domain.IncomeReceipt.removeDocuments(oldValue, $this);
}
Domain.IncomeReceipt.addDocuments(value, $this);
}
}
static setResponseLog = ($this, value) => {
var oldValue = $this.ResponseLog;
$this.ResponseLog = value;
if (value != null) {
}
}
static setIssuer = ($this, value) => {
var oldValue = $this.Issuer;
$this.Issuer = value;
if (value != null) {
}
}
static setCounterpart = ($this, value) => {
var oldValue = $this.Counterpart;
$this.Counterpart = value;
if (value != null) {
}
}
static setInvoiceHeader = ($this, value) => {
var oldValue = $this.InvoiceHeader;
$this.InvoiceHeader = value;
if (value != null) {
}
}
static setPaymentMethods = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentMethods == null) $this.PaymentMethods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentMethods.length > 0) {
                    Domain.AadeBookInvoiceType.removePaymentMethods($this, $this.PaymentMethods[0]);
                }

                Domain.AadeBookInvoiceType.addManyPaymentMethods($this, copyItems);
            }
static addManyPaymentMethods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addPaymentMethods($this, items[i]);
                }
            }
static addPaymentMethods = ($this, item) => {
                if ($this.PaymentMethods == null) $this.PaymentMethods = [];
                if (item == null || $this.PaymentMethods.indexOf(item) > -1) return;
                $this.PaymentMethods.push(item);
}
static addRangePaymentMethods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addPaymentMethods($this, item));
            }
static removePaymentMethods = ($this, item) => {
                if ($this == null || $this.PaymentMethods == null || $this.PaymentMethods.indexOf(item) === -1) return;
                var _index = $this.PaymentMethods.indexOf(item);
                $this.PaymentMethods.splice(_index, 1);
}
static clearPaymentMethods = ($this) => { $this.PaymentMethods = null; }
static setInvoiceDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.InvoiceDetails == null) $this.InvoiceDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InvoiceDetails.length > 0) {
                    Domain.AadeBookInvoiceType.removeInvoiceDetails($this, $this.InvoiceDetails[0]);
                }

                Domain.AadeBookInvoiceType.addManyInvoiceDetails($this, copyItems);
            }
static addManyInvoiceDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addInvoiceDetails($this, items[i]);
                }
            }
static addInvoiceDetails = ($this, item) => {
                if ($this.InvoiceDetails == null) $this.InvoiceDetails = [];
                if (item == null || $this.InvoiceDetails.indexOf(item) > -1) return;
                $this.InvoiceDetails.push(item);
}
static addRangeInvoiceDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addInvoiceDetails($this, item));
            }
static removeInvoiceDetails = ($this, item) => {
                if ($this == null || $this.InvoiceDetails == null || $this.InvoiceDetails.indexOf(item) === -1) return;
                var _index = $this.InvoiceDetails.indexOf(item);
                $this.InvoiceDetails.splice(_index, 1);
}
static clearInvoiceDetails = ($this) => { $this.InvoiceDetails = null; }
static setTaxesTotals = ($this, items) => {
                if (items == null) items = [];
                if ($this.TaxesTotals == null) $this.TaxesTotals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TaxesTotals.length > 0) {
                    Domain.AadeBookInvoiceType.removeTaxesTotals($this, $this.TaxesTotals[0]);
                }

                Domain.AadeBookInvoiceType.addManyTaxesTotals($this, copyItems);
            }
static addManyTaxesTotals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addTaxesTotals($this, items[i]);
                }
            }
static addTaxesTotals = ($this, item) => {
                if ($this.TaxesTotals == null) $this.TaxesTotals = [];
                if (item == null || $this.TaxesTotals.indexOf(item) > -1) return;
                $this.TaxesTotals.push(item);
}
static addRangeTaxesTotals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addTaxesTotals($this, item));
            }
static removeTaxesTotals = ($this, item) => {
                if ($this == null || $this.TaxesTotals == null || $this.TaxesTotals.indexOf(item) === -1) return;
                var _index = $this.TaxesTotals.indexOf(item);
                $this.TaxesTotals.splice(_index, 1);
}
static clearTaxesTotals = ($this) => { $this.TaxesTotals = null; }
static setInvoiceSummary = ($this, value) => {
var oldValue = $this.InvoiceSummary;
$this.InvoiceSummary = value;
if (value != null) {
}
}
static setRelatedAADEBookingType = ($this, value) => {
var oldValue = $this.RelatedAADEBookingType;
$this.RelatedAADEBookingType = value;
if (value != null) {
}
}
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}
static setRelatedERPAADEBookingType = ($this, value) => {
var oldValue = $this.RelatedERPAADEBookingType;
$this.RelatedERPAADEBookingType = value;
if (value != null) {
}
}
static setTransmissionFailure = ($this, value) => {
var oldValue = $this.TransmissionFailure;
$this.TransmissionFailure = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setVATTotals = ($this, items) => {
                if (items == null) items = [];
                if ($this.VATTotals == null) $this.VATTotals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.VATTotals.length > 0) {
                    Domain.AadeBookInvoiceType.removeVATTotals($this, $this.VATTotals[0]);
                }

                Domain.AadeBookInvoiceType.addManyVATTotals($this, copyItems);
            }
static addManyVATTotals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addVATTotals($this, items[i]);
                }
            }
static addVATTotals = ($this, item) => {
                if ($this.VATTotals == null) $this.VATTotals = [];
                if (item == null || $this.VATTotals.indexOf(item) > -1) return;
                $this.VATTotals.push(item);
}
static addRangeVATTotals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addVATTotals($this, item));
            }
static removeVATTotals = ($this, item) => {
                if ($this == null || $this.VATTotals == null || $this.VATTotals.indexOf(item) === -1) return;
                var _index = $this.VATTotals.indexOf(item);
                $this.VATTotals.splice(_index, 1);
}
static clearVATTotals = ($this) => { $this.VATTotals = null; }
static setGeneralJournals = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournals.length > 0) {
                    Domain.AadeBookInvoiceType.removeGeneralJournals($this, $this.GeneralJournals[0]);
                }

                Domain.AadeBookInvoiceType.addManyGeneralJournals($this, copyItems);
            }
static addManyGeneralJournals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addGeneralJournals($this, items[i]);
                }
            }
static addGeneralJournals = ($this, item) => {
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];
                if (item == null || $this.GeneralJournals.indexOf(item) > -1) return;
                $this.GeneralJournals.push(item);
}
static addRangeGeneralJournals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addGeneralJournals($this, item));
            }
static removeGeneralJournals = ($this, item) => {
                if ($this == null || $this.GeneralJournals == null || $this.GeneralJournals.indexOf(item) === -1) return;
                var _index = $this.GeneralJournals.indexOf(item);
                $this.GeneralJournals.splice(_index, 1);
}
static clearGeneralJournals = ($this) => { $this.GeneralJournals = null; }
static setCorrelatedInvoicesOpposite = ($this, items) => {
                if (items == null) items = [];
                if ($this.CorrelatedInvoicesOpposite == null) $this.CorrelatedInvoicesOpposite = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CorrelatedInvoicesOpposite.length > 0) {
                    Domain.AadeBookInvoiceType.removeCorrelatedInvoicesOpposite($this, $this.CorrelatedInvoicesOpposite[0]);
                }

                Domain.AadeBookInvoiceType.addManyCorrelatedInvoicesOpposite($this, copyItems);
            }
static addManyCorrelatedInvoicesOpposite = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addCorrelatedInvoicesOpposite($this, items[i]);
                }
            }
static addCorrelatedInvoicesOpposite = ($this, item) => {
                if ($this.CorrelatedInvoicesOpposite == null) $this.CorrelatedInvoicesOpposite = [];
                if (item == null || $this.CorrelatedInvoicesOpposite.indexOf(item) > -1) return;
                $this.CorrelatedInvoicesOpposite.push(item);
Domain.AadeBookInvoiceType.addCorrelatedInvoices(item, $this);
}
static addRangeCorrelatedInvoicesOpposite = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addCorrelatedInvoicesOpposite($this, item));
            }
static removeCorrelatedInvoicesOpposite = ($this, item) => {
                if ($this == null || $this.CorrelatedInvoicesOpposite == null || $this.CorrelatedInvoicesOpposite.indexOf(item) === -1) return;
                var _index = $this.CorrelatedInvoicesOpposite.indexOf(item);
                $this.CorrelatedInvoicesOpposite.splice(_index, 1);
Domain.AadeBookInvoiceType.removeCorrelatedInvoices(item, $this);
}
static clearCorrelatedInvoicesOpposite = ($this) => { $this.CorrelatedInvoicesOpposite = null; }
static setCorrelatedInvoices = ($this, items) => {
                if (items == null) items = [];
                if ($this.CorrelatedInvoices == null) $this.CorrelatedInvoices = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CorrelatedInvoices.length > 0) {
                    Domain.AadeBookInvoiceType.removeCorrelatedInvoices($this, $this.CorrelatedInvoices[0]);
                }

                Domain.AadeBookInvoiceType.addManyCorrelatedInvoices($this, copyItems);
            }
static addManyCorrelatedInvoices = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addCorrelatedInvoices($this, items[i]);
                }
            }
static addCorrelatedInvoices = ($this, item) => {
                if ($this.CorrelatedInvoices == null) $this.CorrelatedInvoices = [];
                if (item == null || $this.CorrelatedInvoices.indexOf(item) > -1) return;
                $this.CorrelatedInvoices.push(item);
Domain.AadeBookInvoiceType.addCorrelatedInvoicesOpposite(item, $this);
}
static addRangeCorrelatedInvoices = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addCorrelatedInvoices($this, item));
            }
static removeCorrelatedInvoices = ($this, item) => {
                if ($this == null || $this.CorrelatedInvoices == null || $this.CorrelatedInvoices.indexOf(item) === -1) return;
                var _index = $this.CorrelatedInvoices.indexOf(item);
                $this.CorrelatedInvoices.splice(_index, 1);
Domain.AadeBookInvoiceType.removeCorrelatedInvoicesOpposite(item, $this);
}
static clearCorrelatedInvoices = ($this) => { $this.CorrelatedInvoices = null; }
static setDeliveryNotes = ($this, items) => {
                if (items == null) items = [];
                if ($this.DeliveryNotes == null) $this.DeliveryNotes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DeliveryNotes.length > 0) {
                    Domain.AadeBookInvoiceType.removeDeliveryNotes($this, $this.DeliveryNotes[0]);
                }

                Domain.AadeBookInvoiceType.addManyDeliveryNotes($this, copyItems);
            }
static addManyDeliveryNotes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addDeliveryNotes($this, items[i]);
                }
            }
static addDeliveryNotes = ($this, item) => {
                if ($this.DeliveryNotes == null) $this.DeliveryNotes = [];
                if (item == null || $this.DeliveryNotes.indexOf(item) > -1) return;
                $this.DeliveryNotes.push(item);
}
static addRangeDeliveryNotes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addDeliveryNotes($this, item));
            }
static removeDeliveryNotes = ($this, item) => {
                if ($this == null || $this.DeliveryNotes == null || $this.DeliveryNotes.indexOf(item) === -1) return;
                var _index = $this.DeliveryNotes.indexOf(item);
                $this.DeliveryNotes.splice(_index, 1);
}
static clearDeliveryNotes = ($this) => { $this.DeliveryNotes = null; }
static setWithheldTaxReportSummary = ($this, value) => {
var oldValue = $this.WithheldTaxReportSummary;
$this.WithheldTaxReportSummary = value;
if (value != null) {
}
}
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setExternalInvoiceInfo = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExternalInvoiceInfo == null) $this.ExternalInvoiceInfo = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExternalInvoiceInfo.length > 0) {
                    Domain.AadeBookInvoiceType.removeExternalInvoiceInfo($this, $this.ExternalInvoiceInfo[0]);
                }

                Domain.AadeBookInvoiceType.addManyExternalInvoiceInfo($this, copyItems);
            }
static addManyExternalInvoiceInfo = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addExternalInvoiceInfo($this, items[i]);
                }
            }
static addExternalInvoiceInfo = ($this, item) => {
                if ($this.ExternalInvoiceInfo == null) $this.ExternalInvoiceInfo = [];
                if (item == null || $this.ExternalInvoiceInfo.indexOf(item) > -1) return;
                $this.ExternalInvoiceInfo.push(item);
if (item.AadeBookInvoiceType != $this) {
Domain.ExternalInvoiceInfo.setAadeBookInvoiceType(item, $this);
}
}
static addRangeExternalInvoiceInfo = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addExternalInvoiceInfo($this, item));
            }
static removeExternalInvoiceInfo = ($this, item) => {
                if ($this == null || $this.ExternalInvoiceInfo == null || $this.ExternalInvoiceInfo.indexOf(item) === -1) return;
                var _index = $this.ExternalInvoiceInfo.indexOf(item);
                $this.ExternalInvoiceInfo.splice(_index, 1);
item.AadeBookInvoiceType = null;
}
static clearExternalInvoiceInfo = ($this) => { $this.ExternalInvoiceInfo = null; }
static setCashier = ($this, value) => {
var oldValue = $this.Cashier;
$this.Cashier = value;
if (value != null) {
}
}
static setCanceledBy = ($this, value) => {
var oldValue = $this.CanceledBy;
$this.CanceledBy = value;
if (value != null) {
}
}
static setIssuedBy = ($this, value) => {
var oldValue = $this.IssuedBy;
$this.IssuedBy = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setCancellation = ($this, value) => {
var oldValue = $this.Cancellation;
$this.Cancellation = value;
if (value != null) {
}
}
static setCancellationInvoice = ($this, value) => {
var oldValue = $this.CancellationInvoice;
$this.CancellationInvoice = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.AadeBookInvoiceType.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.AadeBookInvoiceType.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AadeBookInvoiceType.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AadeBookInvoiceType.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }
static setAdvancePayments = ($this, value) => {
var oldValue = $this.AdvancePayments;
$this.AdvancePayments = value;
if (value != null) {
}
}

static AddERPItemToRow($this: any, erpItem: any,row: any): any{Domain.InvoiceRowType.setGood(row, erpItem);
let classifications = erpItem?.Classifications?.linq?.where((c) => c?.TransactionType == $this?.TransactionType)?.toArray();
if (classifications?.linq?.any()) {}
}
static AutoFillPaymentMethod($this: any): any{if (!($this?.PaymentMethods?.linq?.any()) && $this?.InvoiceHeader?.InvoiceType?.DefaultPaymentMethod != null) {let paymentMethodDetailType = new Domain.PaymentMethodDetailType();Domain.PaymentMethodDetailType.setPaymentMethod(paymentMethodDetailType, $this?.InvoiceHeader?.InvoiceType?.DefaultPaymentMethod);$this?.PaymentMethods?.add(paymentMethodDetailType);}
}
static AutoFillPaymentMethodAmount($this: any, paymentMethod: any): any{for (let _ipaymentMethodDetailType = 0; _ipaymentMethodDetailType < ($this?.PaymentMethods == null ? 0 : $this?.PaymentMethods.length); _ipaymentMethodDetailType++) {let paymentMethodDetailType = $this?.PaymentMethods[_ipaymentMethodDetailType];if (CLMS.Framework.Number.GreaterThan(() => paymentMethodDetailType.Amount, () => $this.InvoiceSummary.TotalGrossValue)) {paymentMethodDetailType.Amount = $this?.InvoiceSummary?.TotalGrossValue;}}
let existingAmount = $this?.PaymentMethods?.linq?.where((p) => p != paymentMethod)?.toArray()?.linq?.sum((c) => c?.Amount);
let remainingAmount = Joove.Common.safeNumber($this?.InvoiceSummary?.TotalGrossValue) - Joove.Common.safeNumber(existingAmount);
paymentMethod.Amount = remainingAmount;
}
static CanSyncGoods($this: any): any{let hasGood = $this?.InvoiceDetails?.linq?.any((row) => row?.Good?.TransactionItemType == Domain.TransactionItemType.Good);
return hasGood;
}
static ConnectClassificationsWithERP($this: any): any{for (let _iline = 0; _iline < ($this?.InvoiceDetails == null ? 0 : $this?.InvoiceDetails.length); _iline++) {let line = $this?.InvoiceDetails[_iline];for (let _iincomeClassification = 0; _iincomeClassification < (line?.IncomeClassification == null ? 0 : line?.IncomeClassification.length); _iincomeClassification++) {let incomeClassification = line?.IncomeClassification[_iincomeClassification];incomeClassification.ERPAA = $this?.ERPAA;incomeClassification.ERPDocID = $this?.ERPDocID;Domain.IncomeClassificationType.setERPInvoiceCategory(incomeClassification, $this?.ERPInvoiceCategory);Domain.IncomeClassificationType.setERPInvoiceType(incomeClassification, $this?.ERPInvoiceType);}}
}
static FillSpecified($this: any): any{}
static GetBackOfficeDocumentTypeStr($this: any): any{if (($this?.BackOfficeDocumentType == Domain.BackOfficeDocumentType.Proeispraxi)) {return "Προείσπραξη";}else if (($this?.BackOfficeDocumentType == Domain.BackOfficeDocumentType.Eispraxi)) {return "Είσπραξη";}else {return $this?.BackOfficeDocumentType?.toString() + ")";}
}
static GetClassificationMark($this: any): any{return $this?.ClassificationMark;
}
static GetClassificationStatus($this: any): any{let netValue = $this?.InvoiceDetails?.linq?.sum((r) => r?.NetValue);
let classificationAmount = null;
if ($this?.TransactionType == Domain.TransactionType.Income) {classificationAmount = (Joove.Common.cast($this?.InvoiceDetails?.linq?.selectMany((r) => r?.IncomeClassification)?.toArray(), "System.Collections.List"))?.linq?.sum((c) => c?.Amount);}
if ($this?.TransactionType == Domain.TransactionType.Expense) {classificationAmount = (Joove.Common.cast($this?.InvoiceDetails?.linq?.selectMany((r) => r?.ExpensesClassification)?.toArray(), "System.Collections.List"))?.linq?.sum((c) => c?.Amount);}
if (CLMS.Framework.Number.LessThanOrEqual(() => classificationAmount, () => 0)) {return Domain.AadeInvoiceClassificationStatus.NotClassified;}
if (CLMS.Framework.Number.LessThan(() => classificationAmount, () => netValue)) {return Domain.AadeInvoiceClassificationStatus.PartiallyClassified;}
return Domain.AadeInvoiceClassificationStatus.Classified;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetCorrelatedInvoicesStr($this: any): any{if (!($this?.CorrelatedInvoices?.linq?.any())) {return "";}
return CLMS.Framework.String.Join(", ", $this?.CorrelatedInvoices?.linq?.select((i) => i?.Mark)?.toArray());
}
static GetCreditAmount($this: any): any{if (!($this?.CorrelatedInvoicesOpposite?.linq?.any())) {return 0;}
return $this?.CorrelatedInvoicesOpposite?.linq?.where((i) => i?.InvoiceHeader?.InvoiceType?.Code == Domain.InvoiceType.Item51)?.toArray()?.linq?.sum((i) => i?.InvoiceSummary?.TotalGrossValue);
}
static GetIsPaid($this: any): any{return Domain.CommonMethodsHelper.AmountsAreEqual(Domain.AadeBookInvoiceType.GetRemainingAmount($this), 0, null);
}
static GetMyDataSyncStatusStr($this: any): any{if ($this?.Status == Domain.Status.Cancelled) {return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_CANCELED');}
switch ($this?.MyDataSyncStatus) {case Domain.MyDataSyncStatus.None:
{
return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_NONE');}
case Domain.MyDataSyncStatus.SubmitInvoice:
{
return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_INVOICE');}
case Domain.MyDataSyncStatus.SubmitClassifications:
{
return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_CLASSIFICATIONS');}
case Domain.MyDataSyncStatus.FillClassifications:
{
return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_FILL_CLASSIFICATIONS');}
case Domain.MyDataSyncStatus.CompleteInvoice:
{
return this.translate.instant('AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_COMPLETE_INVOICE');}
default:
{
return "";}
}
return "";
}
static GetPayableAmount($this: any): any{return Joove.Common.safeNumber($this?.InvoiceSummary?.TotalGrossValue) - Joove.Common.safeNumber($this?.InvoiceSummary?.NonPrepaidWithheldAmount) - Joove.Common.safeNumber($this?.InvoiceSummary?.NonPrepaidDeductionsAmount) - Joove.Common.safeNumber(Domain.AadeBookInvoiceType.GetCreditAmount($this));
}
static GetPayment($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.PaymentOrderInvoices.length, () => 0)) {return null;}
let paymentOrderInvoice = $this?.PaymentOrderInvoices?.linq?.where((i) => i?.PaymentOrder?.IsPayed)?.toArray()?.linq?.where()?.firstOrDefault(null);
if (paymentOrderInvoice == null) {return null;}
return paymentOrderInvoice?.PaymentOrder?.Payment;
}
static GetPaymentMethodStr($this: any): any{if (!($this?.PaymentMethods?.linq?.any())) {return "";}
return $this?.PaymentMethods?.linq?.where()?.firstOrDefault(null)?.PaymentMethod?.Name;
}
static GetRemainingAmount($this: any): any{return Joove.Common.safeNumber(Domain.AadeBookInvoiceType.GetPayableAmount($this)) - Joove.Common.safeNumber($this?.PaidAmount);
}
static IsCreditInvoice($this: any): any{return $this?.InvoiceHeader?.InvoiceType?.Name?.indexOf("5.1") === 0 || $this?.InvoiceHeader?.InvoiceType?.Code == Domain.InvoiceType.Item51 || $this?.InvoiceHeader?.InvoiceType?.Name?.indexOf("5.2") === 0 || $this?.InvoiceHeader?.InvoiceType?.Code == Domain.InvoiceType.Item52;
}
static IsFromBackOffice($this: any): any{return !(CLMS.Framework.String.IsNullOrEmpty($this?.ExternalSourceId));
}
static IssuedByUs($this: any): any{return $this?.Issuer != null && $this?.Issuer?.VatNumber == $this?.Entity?.TaxNumber;
}
static MergeFromMyData($this: any, invoice: any): any{$this.UID = invoice?.UID;
$this.Mark = invoice?.Mark;
$this.ClassificationMark = invoice?.ClassificationMark;
if (CLMS.Framework.Number.GreaterThan(() => invoice.CancelledByMark, () => 0)) {$this.CancelledByMark = invoice?.CancelledByMark;}
$this.AuthenticationCode = invoice?.AuthenticationCode;
$this.Source = invoice?.Source;
$this.TransactionType = invoice?.TransactionType;
$this.Status = invoice?.Status;
$this.ERPAA = invoice?.ERPAA;
$this.ERPDocID = invoice?.ERPDocID;
$this.IsCurrent = invoice?.IsCurrent;
Domain.AadeBookInvoiceType.setInvoiceSummary($this, invoice?.InvoiceSummary);
Domain.AadeBookInvoiceType.setTaxesTotals($this, invoice?.TaxesTotals);
Domain.AadeBookInvoiceType.setInvoiceHeader($this, invoice?.InvoiceHeader);
Domain.AadeBookInvoiceType.setIssuer($this, invoice?.Issuer);
Domain.AadeBookInvoiceType.setCounterpart($this, invoice?.Counterpart);
}
static PrepareInvoiceToSendToMyData($this: any): any{if ($this?.TransactionType == Domain.TransactionType.Income) {Domain.AadeBookInvoiceType.setIssuer($this, new Domain.PartyType());if (Domain.Country.ToCountryType($this?.Entity?.Country) != Domain.CountryType.GR) {$this.Issuer.Name = $this?.Entity?.Name;}$this.Issuer.Country = Domain.Country.ToCountryType($this?.Entity?.Country);$this.Issuer.VatNumber = $this?.Entity?.TaxNumber;let issuerAddress = $this?.Entity?.Addresses?.linq?.where()?.firstOrDefault(null);Domain.PartyType.setAddress($this.Issuer, new Domain.AddressType());$this.Issuer.Address.Street = issuerAddress?.StreetName;$this.Issuer.Address.Number = issuerAddress?.StreetNumber;$this.Issuer.Address.PostalCode = issuerAddress?.PostalCode;$this.Issuer.Address.City = issuerAddress?.City;Domain.AadeBookInvoiceType.setCounterpart($this, new Domain.PartyType());$this.Counterpart.Name = $this?.TransactionEntity?.BusinessEntityName;$this.Counterpart.Country = Domain.Country.ToCountryType($this?.TransactionEntity?.InvoiceAddress?.Country);$this.Counterpart.VatNumber = $this?.TransactionEntity?.VATNumber;let counterpartAddress = $this?.TransactionEntity?.InvoiceAddress;Domain.PartyType.setAddress($this.Counterpart, new Domain.AddressType());$this.Counterpart.Address.Street = counterpartAddress?.StreetName;$this.Counterpart.Address.Number = counterpartAddress?.StreetNumber;$this.Counterpart.Address.PostalCode = counterpartAddress?.PostalCode;$this.Counterpart.Address.City = counterpartAddress?.City;}else if ($this?.TransactionType == Domain.TransactionType.Expense) {Domain.AadeBookInvoiceType.setIssuer($this, new Domain.PartyType());if (Domain.Country.ToCountryType($this?.TransactionEntity?.InvoiceAddress?.Country) != Domain.CountryType.GR) {$this.Issuer.Name = $this?.TransactionEntity?.FullName;}$this.Issuer.Country = Domain.Country.ToCountryType($this?.TransactionEntity?.InvoiceAddress?.Country);$this.Issuer.VatNumber = $this?.TransactionEntity?.VATNumber;let issuerAddress = $this?.TransactionEntity?.InvoiceAddress;Domain.PartyType.setAddress($this.Issuer, new Domain.AddressType());$this.Issuer.Address.Street = issuerAddress?.StreetName;$this.Issuer.Address.Number = issuerAddress?.StreetNumber;$this.Issuer.Address.PostalCode = issuerAddress?.PostalCode;$this.Issuer.Address.City = issuerAddress?.City;Domain.AadeBookInvoiceType.setCounterpart($this, new Domain.PartyType());$this.Counterpart.Name = $this?.Entity?.Name;$this.Counterpart.Country = Domain.Country.ToCountryType($this?.Entity?.Country);$this.Counterpart.VatNumber = $this?.Entity?.TaxNumber;let counterpartAddress = $this?.Entity?.Addresses?.linq?.where()?.firstOrDefault(null);Domain.PartyType.setAddress($this.Counterpart, new Domain.AddressType());$this.Counterpart.Address.Street = counterpartAddress?.StreetName;$this.Counterpart.Address.Number = counterpartAddress?.StreetNumber;$this.Counterpart.Address.PostalCode = counterpartAddress?.PostalCode;$this.Counterpart.Address.City = counterpartAddress?.City;}
}
static RefreshLineNumbers($this: any): any{let i = 1;
for (let _iline = 0; _iline < ($this?.InvoiceDetails == null ? 0 : $this?.InvoiceDetails.length); _iline++) {let line = $this?.InvoiceDetails[_iline];line.LineNumber = i;i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1);}
}
static RoundAmount($this: any, amount: any): any{if ($this?.Entity == null) {return amount;}
return Domain.BusinessEntity.RoundCurrencyAmount($this?.Entity, amount);
}
static SanitizeMyDataInvoiceRequest(invoice: any): any{if (invoice.issuer.country == 87 /* Interfaces.AADESchema.CountryType.GR */) {invoice.issuer.name = null;invoice.issuer.address = null;}
if (invoice.counterpart.country == 87 /* Interfaces.AADESchema.CountryType.GR */) {invoice.counterpart.name = null;invoice.counterpart.address = null;}
for (let _irow = 0; _irow < (invoice.invoiceDetails == null ? 0 : invoice.invoiceDetails.length); _irow++) {let row = invoice.invoiceDetails[_irow];if (row.incomeClassification?.linq?.any()) {invoice.invoiceSummary.incomeClassification?.addRange(row.incomeClassification);}if (row.expensesClassification?.linq?.any()) {invoice.invoiceSummary.expensesClassification?.addRange(row.expensesClassification);}}
}
static SaveNewItemsExpense(): any{try {let invoices = [];}
catch (x) {console.error(x);}
}
static SourceTypeStrToEnum(source: any): any{switch ((source)) {case "ERP":
{
return Domain.SourceType.ERP;}
case "LOCAL":
{
return Domain.SourceType.LOCAL;}
case "AADE":
{
return Domain.SourceType.AADE;}
default:
{
return Domain.SourceType.ERP;}
}
}
static UpdateHasMultipleBudgetItems($this: any): any{let uniqueBudgetItems = $this?.InvoiceDetails?.linq?.where((d) => d?.SpendingRequestInvoicing != null && d?.SpendingRequestInvoicing?.SpendingRequestDetail != null && d?.SpendingRequestInvoicing?.SpendingRequestDetail?.SpendingRequest != null && CLMS.Framework.Number.GreaterThan(() => d.SpendingRequestInvoicing.SpendingRequestDetail.SpendingRequest.Id, () => 0) && d?.SpendingRequestInvoicing?.SpendingRequestDetail?.Item != null && CLMS.Framework.Number.GreaterThan(() => d.SpendingRequestInvoicing.SpendingRequestDetail.Item.Id, () => 0))?.toArray()?.linq?.select((d) => d?.SpendingRequestInvoicing?.SpendingRequestDetail?.Item?.BudgetItem?.Id)?.toArray()?.linq?.distinct()?.toArray();
$this.HasMultipleBudgetItems = CLMS.Framework.Number.GreaterThan(() => uniqueBudgetItems.length, () => 1);
}
static UpdateInvoice($this: any): any{let transactionItemTypes = Domain.InvoiceFormFieldsVisibility.GetGoodTypeByInvoiceType($this?.InvoiceHeader?.InvoiceType?.Code);
let linesToRemove = [];
for (let _iline = 0; _iline < ($this?.InvoiceDetails == null ? 0 : $this?.InvoiceDetails.length); _iline++) {let line = $this?.InvoiceDetails[_iline];if (line?.Good == null || transactionItemTypes?.linq?.contains(line?.Good?.TransactionItemType)) {continue;}linesToRemove?.add(line);}
for (let _ilineToRemove = 0; _ilineToRemove < (linesToRemove == null ? 0 : linesToRemove.length); _ilineToRemove++) {let lineToRemove = linesToRemove[_ilineToRemove];$this?.InvoiceDetails?.splice($this?.InvoiceDetails.indexOf(lineToRemove), 1);}
if (!(Domain.InvoiceFormFieldsVisibility.CanBeDeiveryNote($this?.InvoiceHeader?.InvoiceType?.Code))) {$this.InvoiceHeader.IsDeliveryNote = false;}
Domain.AadeBookInvoiceType.AutoFillPaymentMethod($this);
}
static UpdateTaxAmounts($this: any): any{if ($this?.TaxesPerInvoiceLine) {$this.InvoiceSummary.TotalWithheldAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.WithheldAmount);$this.InvoiceSummary.TotalOtherTaxesAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.OtherTaxesAmount);$this.InvoiceSummary.TotalFeesAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.FeesAmount);$this.InvoiceSummary.TotalStampDutyAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.StampDutyAmount);$this.InvoiceSummary.TotalDeductionsAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.DeductionsAmount);$this.InvoiceSummary.NonPrepaidWithheldAmount = $this?.InvoiceDetails?.linq?.where((d) => d?.WithheldPercentCategory != null && !(d?.WithheldPercentCategory?.IsPrepaid))?.toArray()?.linq?.sum((d) => d?.WithheldAmount);$this.InvoiceSummary.PrepaidWithheldAmount = $this?.InvoiceDetails?.linq?.where((d) => d?.WithheldPercentCategory != null && d?.WithheldPercentCategory?.IsPrepaid)?.toArray()?.linq?.sum((d) => d?.WithheldAmount);$this.InvoiceSummary.NonPrepaidDeductionsAmount = $this?.InvoiceDetails?.linq?.where((d) => d?.DeductionsPercentCategory != null && !(d?.DeductionsPercentCategory?.IsPrepaid))?.toArray()?.linq?.sum((d) => d?.DeductionsAmount);$this.InvoiceSummary.PrepaidDeductionsAmount = $this?.InvoiceDetails?.linq?.where((d) => d?.DeductionsPercentCategory != null && d?.DeductionsPercentCategory?.IsPrepaid)?.toArray()?.linq?.sum((d) => d?.DeductionsAmount);}else {$this.InvoiceSummary.TotalWithheldAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.WithHeld)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.TotalOtherTaxesAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.OtherTax)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.TotalFeesAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.Fees)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.TotalStampDutyAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.StampDuty)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.TotalDeductionsAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.Deduction)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.NonPrepaidWithheldAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.WithHeld && !(t?.Tax?.IsPrepaid))?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.PrepaidWithheldAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.WithHeld && t?.Tax?.IsPrepaid)?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.NonPrepaidDeductionsAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.Deduction && !(t?.Tax?.IsPrepaid))?.toArray()?.linq?.sum((d) => d?.TaxAmount);$this.InvoiceSummary.PrepaidDeductionsAmount = $this?.TaxesTotals?.linq?.where((t) => t?.Tax != null && t?.Tax?.Type == Domain.TaxType.Deduction && t?.Tax?.IsPrepaid)?.toArray()?.linq?.sum((d) => d?.TaxAmount);}
$this.InvoiceSummary.TotalTaxesAmount = Joove.Common.safeNumber($this?.InvoiceSummary?.TotalFeesAmount) + Joove.Common.safeNumber($this?.InvoiceSummary?.TotalOtherTaxesAmount);
$this.InvoiceSummary.TotalVatAmount = $this?.InvoiceDetails?.linq?.sum((d) => d?.VatAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}